var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
const SvgWallet = ({
  svgRef,
  title,
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: 97,
  height: 97,
  viewBox: "0 0 97 97",
  fill: "none",
  ref: svgRef
}, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
  opacity: 0.35,
  d: "M72.5 84.5H24.5C17.872 84.5 12.5 79.128 12.5 72.5V24.5H72.5C79.128 24.5 84.5 29.872 84.5 36.5V72.5C84.5 79.128 79.128 84.5 72.5 84.5Z",
  fill: "currentColor"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  d: "M70.5 60.5C73.8137 60.5 76.5 57.8137 76.5 54.5C76.5 51.1863 73.8137 48.5 70.5 48.5C67.1863 48.5 64.5 51.1863 64.5 54.5C64.5 57.8137 67.1863 60.5 70.5 60.5Z",
  fill: "currentColor"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  d: "M12.5 24.5C12.5 17.872 17.872 12.5 24.5 12.5H60.5C67.128 12.5 72.5 17.872 72.5 24.5H12.5Z",
  fill: "currentColor"
})));
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgWallet, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/wallet.307d7f96.svg";
export { ForwardRef as ReactComponent };